import axios from "axios";
// Auth rides in an httpOnly cookie set by the API — nothing token-shaped is
// stored in (or readable from) JavaScript, so XSS cannot steal the session.
const api = axios.create({
    baseURL: (process.env.API_URL || '') + '/v1',
    withCredentials: true,
});
api.interceptors.response.use((r) => r, (err) => {
    if (err.response?.status === 401 && localStorage.getItem("admin_user")) {
        localStorage.removeItem("admin_user");
        window.location.href = "/login";
    }
    return Promise.reject(err);
});
export default api;
